import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionPlacementDTO  {
    _originalTypeClassName = "zERP.BO.TransactionPlacementDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionPlacementDTO.translate = translateService;
}
this.GoodPlacements = [];
this.Id = null;
this.Quantity = null;
this.UnallocatedQuantity = null;
this.LiveUnallocatedQuantity = null;
this.CostPerUnit = null;
this.Expanded = false;
this.Date = null;
this.IsPurchase = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Quantity:any;
UnallocatedQuantity:any;
LiveUnallocatedQuantity:any;
CostPerUnit:any;
Expanded:any;
Date:any;
IsPurchase:any;
Good:any;
GoodPlacements:any;
Warehouse:any;
static setGood = ($this, value) => {
var oldValue = $this.Good;
$this.Good = value;
if (value != null) {
}
}
static setGoodPlacements = ($this, items) => {
                if (items == null) items = [];
                if ($this.GoodPlacements == null) $this.GoodPlacements = [];

                const copyItems = Common.cloneObject(items);

                while ($this.GoodPlacements.length > 0) {
                    Domain.TransactionPlacementDTO.removeGoodPlacements($this, $this.GoodPlacements[0]);
                }

                Domain.TransactionPlacementDTO.addManyGoodPlacements($this, copyItems);
            }
static addManyGoodPlacements = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TransactionPlacementDTO.addGoodPlacements($this, items[i]);
                }
            }
static addGoodPlacements = ($this, item) => {
                if ($this.GoodPlacements == null) $this.GoodPlacements = [];
                if (item == null || $this.GoodPlacements.indexOf(item) > -1) return;
                $this.GoodPlacements.push(item);
}
static addRangeGoodPlacements = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TransactionPlacementDTO.addGoodPlacements($this, item));
            }
static removeGoodPlacements = ($this, item) => {
                if ($this == null || $this.GoodPlacements == null || $this.GoodPlacements.indexOf(item) === -1) return;
                var _index = $this.GoodPlacements.indexOf(item);
                $this.GoodPlacements.splice(_index, 1);
}
static clearGoodPlacements = ($this) => { $this.GoodPlacements = null; }
static setWarehouse = ($this, value) => {
var oldValue = $this.Warehouse;
$this.Warehouse = value;
if (value != null) {
}
}

static QuantitySum($this: any): any{return $this?.GoodPlacements?.linq?.sum((x) => x?.Quantity);
}
static ToTransfers($this: any, isPurchase: any): any{let r = [];
for (let _igoodPlacement = 0; _igoodPlacement < ($this?.GoodPlacements == null ? 0 : $this?.GoodPlacements.length); _igoodPlacement++) {let goodPlacement = $this?.GoodPlacements[_igoodPlacement];let transfer = new Domain.GoodTransfer();Domain.GoodTransfer.setGood(transfer, $this?.Good);transfer.CostPerUnit = $this?.CostPerUnit;transfer.Date = $this?.Date;Domain.GoodTransfer.setWarehouse(transfer, goodPlacement?.Warehouse);transfer.Quantity = goodPlacement?.Quantity;if (!(isPurchase)) {transfer.Quantity = Joove.Common.safeNumber(0) - Joove.Common.safeNumber(transfer?.Quantity);}r?.add(transfer);}
return r;
}
static ToTransfersInternal($this: any): any{if (CLMS.Framework.Number.NotEqual(() => $this.Quantity, () => Domain.TransactionPlacementDTO.QuantitySum($this))) {throw Error("LocalResources.InventoryManagementBO_QUANTITY_SUM_UNEQUAL");}
if (CLMS.Framework.Number.LessThanOrEqual(() => $this.Quantity, () => 0)) {throw Error("LocalResources.InventoryManagementBO_RES_NEGATIVE_QUANTITY");}
let r = [];
let negativeTransfer = new Domain.GoodTransfer();
negativeTransfer.Date = $this?.Date;
negativeTransfer.Quantity = Joove.Common.safeNumber(0) - Joove.Common.safeNumber($this?.Quantity);
Domain.GoodTransfer.setGood(negativeTransfer, $this?.Good);
negativeTransfer.IsTransferIn = false;
Domain.GoodTransfer.setWarehouse(negativeTransfer, $this?.Warehouse);
r?.add(negativeTransfer);
for (let _igoodPlacement = 0; _igoodPlacement < ($this?.GoodPlacements == null ? 0 : $this?.GoodPlacements.length); _igoodPlacement++) {let goodPlacement = $this?.GoodPlacements[_igoodPlacement];let transfer = new Domain.GoodTransfer();transfer.Date = $this?.Date;transfer.Quantity = goodPlacement?.Quantity;Domain.GoodTransfer.setGood(transfer, $this?.Good);transfer.IsTransferIn = true;Domain.GoodTransfer.setWarehouse(transfer, goodPlacement?.Warehouse);r?.add(transfer);}
return r;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}